import axios from "axios";
import cookie from "js-cookie";
import { API_URL, MOCK_API_ENABLED } from "config";
import mockApiResponses from "api/_mockApiResponses";
import qs from "qs";

const authToken =
  cookie("Authorization") === undefined ? "" : cookie("Authorization");

export function get(url, data) {
  if (MOCK_API_ENABLED && mockApiResponses[url]) {
    return Promise.resolve(mockApiResponses[url]);
  }

  return axios
    .get(`${API_URL}${url}`, {
      params: data,
      headers: {
        Authorization: authToken
      }
    })
    .then(handleResponse);
}

export function getBlob(url, data) {
  return axios
    .get(`${API_URL}${url}`, {
      params: data,
      responseType: "arraybuffer",
      headers: {
        Authorization: authToken
      }
    })
    .then(handleResponse);
}

export function post(url, data) {
  return axios
    .post(`${API_URL}${url}`, data, {
      headers: {
        Authorization: authToken
      }
    })
    .then(handleResponse);
}

export function put(url, data) {
  return axios
    .put(`${API_URL}${url}`, data, {
      headers: {
        Authorization: authToken
      }
    })
    .then(handleResponse);
}

export function del(url, params) {
  return axios
    .delete(`${API_URL}${url}`, {
      params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
      headers: {
        Authorization: authToken
      }
    })
    .then(handleResponse);
}

function handleResponse(response) {
  // application/octet-stream

  if (response.headers["content-type"]) {
    const type = response.headers["content-type"];
    if (type.indexOf("text/csv") > -1) {
      const blob = new Blob([response.data], { type: type, encoding: "UTF-8" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "download.csv";
      link.click();
      return;
    } else if (type.indexOf("application/octet-stream") > -1) {
      const blob = new Blob([response.data], { type: type });
      const link = document.createElement("a");
      const contentDisposition = response.headers["content-disposition"];
      let filename = `file.data`; // Default filename
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
        if (filenameMatch) {
          filename = filenameMatch[1];
        }
      }
      const url = URL.createObjectURL(blob);
      link.href = url;
      link.download = filename;
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      return;
    } else if (type.indexOf("application/json;charset=UTF-8") > -1) {
      // ignore
    } else {
      // Handle other content types as needed
      console.warn("Unhandled content type:", response.headers["content-type"]);
    }
  }
  return response.data;
}
